// Escapes HTML characters in a template literal string, to prevent XSS.
// See https://www.owasp.org/index.php/XSS_%28Cross_Site_Scripting%29_Prevention_Cheat_Sheet#RULE_.231_-_HTML_Escape_Before_Inserting_Untrusted_Data_into_HTML_Element_Content
function sanitizeHTML(strings) {
    const entities = {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'};
    let result = strings[0];
    for (let i = 1; i < arguments.length; i++) {
        result += String(arguments[i]).replace(/[&<>'"]/g, (char) => {
            return entities[char];
    });
        result += strings[i];
    }
    return result;
}

function initMap() {
    navigator.geolocation.getCurrentPosition((loc) => {
        var userLat = loc.coords.latitude;
        var userLon = loc.coords.longitude;
        jQuery('.store-locate .item').each(function(){
            var storeLat = jQuery(this).attr('data-lat');
            var storeLon = jQuery(this).attr('data-lon');
            if (storeLon.charAt(0) === ' '){
                storeLon = storeLon.substr(1);
            }

            var radlat1 = Math.PI * userLat/180
            var radlat2 = Math.PI * storeLat/180
            var radlon1 = Math.PI * userLon/180
            var radlon2 = Math.PI * storeLon/180
            var theta = userLon-storeLon
            var radtheta = Math.PI * theta/180
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            dist = Math.acos(dist)
            dist = dist * 180/Math.PI
            dist = dist * 60 * 1.1515
            dist = Math.round( dist * 10 ) / 10;

            jQuery(this).find('.miles p').text(''+dist+' mi');
        });
        
        console.log('User coordinates: '+userLat+', '+userLon);
        $.ajax({
            url: ajaxurl,
            type: "POST",
            data: {
                action: "user_position",
                userLat: userLat, 
                userLon: userLon 
            },
            success: function( response ){
                console.log( response );
            }
        })
    });
    
    const map = new google.maps.Map(document.getElementById('map'), {
        zoom: 13,
        center: {lat: lat_data, lng: lng_data}
    });

    const infoWindow = new google.maps.InfoWindow();
    infoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});

    map.data.addGeoJson(stores_data);

    map.data.addListener('click', function (event) {

        const storeName = event.feature.getProperty('location_name');
        const permalink = event.feature.getProperty('permalink');
        const position = event.feature.getGeometry().get();
        const address = event.feature.getProperty('address');
        const city = event.feature.getProperty('city');
        const state = event.feature.getProperty('state');
        const postal_code = event.feature.getProperty('postal_code');
        const primary_phone = event.feature.getProperty('primary_phone');
        const primary_phone_link = 'tel:+1' + primary_phone.replace(/[^\d]/g, '');
        const directions_url = event.feature.getProperty('directions_url');

        const content = sanitizeHTML`
          <div class="map_mark_er">
            <b style="font-size: 21px;">${storeName}</b><br>
            <small>
              ${address},<br>
              ${city}, ${state} ${postal_code}
            </small>
            <p class='map_phone'>phone: <a href="${primary_phone_link}">${primary_phone}</a></p>
            <p class='map_phone'>
              <a target='_blank' class='map_direct' href='${directions_url}'>Directions</a>
              <span><a href='${permalink}'>More Info</a></span>
            </p>
          </div>
        `;

        infoWindow.setContent(content);
        infoWindow.setPosition(position);
        infoWindow.open(map);

    });
}

// function singleDir() {
//     navigator.geolocation.getCurrentPosition((loc) => {
//         var userLat = loc.coords.latitude;
//         var userLon = loc.coords.longitude;
//         jQuery('#location-content .address .link-out').each(function(){
//             var storeLat = jQuery(this).attr('data-lat');
//             var storeLon = jQuery(this).attr('data-lon');
//             if (storeLon.charAt(0) === ' '){
//                 storeLon = storeLon.substr(1);
//             }

//             var radlat1 = Math.PI * userLat/180
//             var radlat2 = Math.PI * storeLat/180
//             var radlon1 = Math.PI * userLon/180
//             var radlon2 = Math.PI * storeLon/180
//             var theta = userLon-storeLon
//             var radtheta = Math.PI * theta/180
//             var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
//             dist = Math.acos(dist)
//             dist = dist * 180/Math.PI
//             dist = dist * 60 * 1.1515
//             dist = Math.round( dist * 10 ) / 10;

//             jQuery(this).find('p').text(''+dist+' mi');

//             console.log('User coordinates: '+userLat+', '+userLon);
//             $.ajax({
//                 url: ajaxurl,
//                 type: "POST",
//                 data: {
//                     action: "user_position",
//                     userLat: userLat, 
//                     userLon: userLon 
//                 },
//                 success: function( response ){
//                     console.log( response );
//                 }
//             })
//         });
//     });
// };